import { useState, useEffect } from 'react'

interface GeoLocation {
  city: string | null
  country: string | null
  isLoading: boolean
  error: string | null
}

export function useUserCity(): GeoLocation {
  const [city, setCity] = useState<string | null>(null)
  const [country, setCountry] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchLocation = async () => {
      // Try multiple APIs in sequence for reliability
      const apis = [
        {
          url: 'https://ipwho.is/',
          getCity: (data: any) => data.city,
          getCountry: (data: any) => data.country,
          isSuccess: (data: any) => data.success !== false && data.city,
        },
        {
          url: 'https://ipapi.co/json/',
          getCity: (data: any) => data.city,
          getCountry: (data: any) => data.country_name,
          isSuccess: (data: any) => !data.error && data.city,
        },
        {
          url: 'https://freeipapi.com/api/json',
          getCity: (data: any) => data.cityName,
          getCountry: (data: any) => data.countryName,
          isSuccess: (data: any) => data.cityName,
        },
      ]

      for (const api of apis) {
        try {
          const response = await fetch(api.url, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          })

          if (!response.ok) continue

          const data = await response.json()

          if (api.isSuccess(data)) {
            const detectedCity = api.getCity(data)
            const detectedCountry = api.getCountry(data)

            if (detectedCity) {
              setCity(detectedCity)
              setCountry(detectedCountry || null)
              setIsLoading(false)
              return // Success! Exit the loop
            }
          }
        } catch (err) {
          // Continue to next API
          console.log(`API ${api.url} failed, trying next...`)
        }
      }

      // All APIs failed
      setError('Could not detect location')
      setIsLoading(false)
    }

    fetchLocation()
  }, [])

  return { city, country, isLoading, error }
}
